/**
 * Typed route constants. Use instead of hardcoded path strings.
 *
 *   navigate(ROUTES.QA_REVIEW)
 *   <Link to={ROUTES.PROJECTS}>
 */
export const ROUTES = {
  // Public
  LOGIN: '/login',
  CLIENT_REVIEW: (projectId: string) => `/client-review/${projectId}`,

  // Project hub
  PROJECTS: '/projects',
  PROJECTS_NEW: '/projects/new',

  // Collection stage
  OVERVIEW: '/',
  SETUP: '/setup',
  IMPORT: '/import',
  LOCATIONS: '/locations',
  REGISTER: '/register',
  TAGS: '/tags',
  BUILDINGS: '/buildings',
  BUILDING_DETAIL: (id: string) => `/buildings/${id}`,
  TEAM: '/team',
  DEVICES: '/devices',
  ASSIGNMENTS: '/assignments',

  // QA stage
  QA_REVIEW: '/qa',
  INVENTORY: '/inventory',
  CONFLICTS: '/conflicts',
  DEFERRED: '/deferred',
  RECONCILIATION: '/reconciliation',
  FINAL_DELIVERY: '/final-delivery',
  EXPORTS: '/exports',

  // Cross-stage
  AI_INSIGHTS: '/ai-insights',
  COMPONENTIZATION: '/componentization',
  ACTIVITY_LOG: '/activity-log',

  // Aliases
  CLASSIFICATIONS: '/import?tab=classifications',
  USERS: '/team?tab=members',
  EXPORT: '/reconciliation',
} as const;
